// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2vHQa","buttons":"SendReceipts_buttons__1ah1A","email":"SendReceipts_email__3Zd4-","bookApptTitle":"SendReceipts_bookApptTitle__2mOpf"};